import { render, staticRenderFns } from "./priceChange.vue?vue&type=template&id=832152b6&scoped=true&"
import script from "./priceChange.vue?vue&type=script&lang=js&"
export * from "./priceChange.vue?vue&type=script&lang=js&"
import style0 from "./priceChange.vue?vue&type=style&index=0&id=832152b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832152b6",
  null
  
)

export default component.exports